import { Button, Form, Modal, notification } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { createAbsence } from "store/slices/absencesSlice";
import { closeModal } from "store/slices/modalsSlice";
import { getSchools } from "store/slices/schoolsSlice";
import AbsenceForm from "./absence-form";

const NewAbsenceModal = () => {
  const { t } = useTranslation();
  const [form] = Form?.useForm();
  const dispatch = useDispatch();
  const { isModalOpen, modalType } = useSelector((state) => state?.modals);
  const { loading } = useSelector((state) => state?.absences);
  const { schools } = useSelector((state) => state?.schools);
  const open = isModalOpen && modalType === "new_absence";

  const { userData } = useSelector((state) => state?.auth);
  useEffect(() => {
    if (open) {
      if (userData?._id) dispatch(getSchools(userData?._id));
    }
  }, [dispatch, open, userData?._id]);

  const onSubmit = async (values) => {
    if (values?.date) {
      values.date = dayjs(values?.date)?.format("YYYY-MM-DD");
    }
    if (values?.hour) {
      values.hour = dayjs(values?.hour)?.format("HH:MM");
    }
    return await dispatch(createAbsence(values))?.unwrap()?.then(() => {
        notification?.success({
          message: t("absences.crud.form.success"),
        });
        onClose();
      })?.catch((error) => {
        notification?.error({
          message: t("absences.crud.form.error.failed"),
        });
      });
  };

  const onClose = () => {
    form?.resetFields();
    dispatch(closeModal());
  };
  return (
    <Modal
      title={<h4 style={{ textAlign: "center" }}>{t("absences.crud.form")}</h4>}
      open={open}
      onCancel={onClose}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onClose}>
          {t("absences.crud.form.button.cancel")}
        </Button>,
        <Button
          key="submit"
          type="primary"
          htmlType="submit"
          form="absence_form"
          disabled={loading}
        >
          {t("absences.crud.form.button.save")}
        </Button>,
      ]}
      centered
      styles={{ content: { overflowY: "auto", maxHeight: "75vh" } }}
    >
      <AbsenceForm schools={schools} onSubmit={onSubmit} form={form} />
    </Modal>
  );
};

export default NewAbsenceModal;
